import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Label,
  FormGroup,
  Button,
  Alert,
  InputGroup,
  InputGroupAddon,
  Spinner,
  UncontrolledAlert,
} from "reactstrap";
import {
  AvForm,
  AvGroup,
  AvInput,
  AvFeedback,
  AvField,
} from "availity-reactstrap-validation";
import { User, Mail } from "react-feather";
import { isMobile } from "react-device-detect";
import { withTranslation } from "react-i18next";
import Dialog from "./../../component/common/Dialog";
import ContactDialog from "./ContactDialog";
import Cookies from "js-cookie";

const axios = require("axios").default;

class ContactOne extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: "",
      lastName: "",
      email: "",
      displayEmail: "",
      showDialog: false,
      isAlreadyRegistered: false,
      showResultDialog: false,
      showDialogWhenMoveOutside: true,
      isDisabled: false
    };
    this.formRef = React.createRef();
    this.timer = null;
  }

  handleMouseLeave = (event) => {
    if (event.clientY <= 0) {
      console.log("Exit intent: user moved mouse to top (maybe closing tab).");
    } else {
      console.log("Mouse left page from side or bottom.");
    }

    if (this.mouseInside) {
  console.log("Pointer is still inside page content");
} else {
  console.log("Pointer is outside");
}

    if (this.state.showDialogWhenMoveOutside) {
      //const keepInform = Cookies.get("keepinform");
      //alert(`showDialogWhenMoveOutside keepinform: ${keepInform}`)
      const keepInform = localStorage.getItem('keepinform')

      if (keepInform == null) {
        this.setState({ showDialog: true, showDialogWhenMoveOutside: false });
      }
    }
  };

  componentDidMount() {
    // Set a timeout to show dialog after 5 minute (300000 milliseconds)
    /*
    const keepInform = Cookies.get("keepinform");
    if (keepInform == null) {
      this.timer = setTimeout(() => {
        this.setState({ showDialog: true });
      }, 5000);
    }
    */

    // document.addEventListener("mouseleave", (e) => {
    //   console.log("Mouse left the window!", e);
    //   const keepInform = Cookies.get("keepinform");
    //   if (keepInform == null) {
    //     this.setState({ showDialog: true });
    //   }
    // });
    document.body.addEventListener("mouseleave", this.handleMouseLeave);
  }

  componentWillUnmount() {
    // Clear the timer when component unmounts to prevent memory leaks
    if (this.timer) {
      clearTimeout(this.timer);
    }
    document.body.removeEventListener("mouseleave", this.handleMouseLeave);
  }

  toggleDialog = () => {
    this.setState((prevState) => ({
      showDialog: !prevState.showDialog,
    }));
  };

  toggleResultDialog = () => {
    this.setState((prevState) => ({
      showResultDialog: !prevState.showResultDialog,
    }));
  };

  handleSendMessage = (event, { firstName, lastName, email, isPro }) => {
    // Current language code (e.g., 'en', 'fr')
    const currentLanguage = this.props.i18n.language;

    // alert(`${firstName} ${lastName} ${email} ${currentLanguage} ${isPro}`);

    const body = {
      type: "contact_us",
      status: "open",
      firstName: firstName,
      lastName: lastName,
      email: email,
      language: currentLanguage,
      pro: isPro,
    };
    const headers = { "Content-Type": "application/json" };
    const url = "/api/v0-1/keep-me-informed";

    this.setState({
      isDisabled: true,
      showDialog: false,
      firstName: firstName,
      lastName: lastName,
      email: email,
    });

    const instance = axios.create({
      baseURL: process.env.REACT_APP_API_BASE_URL,
      timeout: 10000,
      headers: headers,
    });
    console.log(process.env.REACT_APP_API_BASE_URL);
    console.log(process.env.REACT_APP_API_BASE_URL + url);
    instance
      .post(url, body)
      .then((response) => {
        console.log(response);
        return response;
      })
      .then((json) => {
        //alert("You message has been sent!");
        if (this.formRef.current) {
          this.formRef.current.reset(); // ✅ correct
        }

        const isAlreadyRegistered = json?.data?.message == 'Already registered.'
        console.log(`isAlreadyRegistered: ${isAlreadyRegistered}`)
        this.setState({
          isDisabled: false,
          firstName: "",
          email: "",
          lastName: "",
          isAlreadyRegistered: isAlreadyRegistered,
          showResultDialog: true,
        });

        //Cookies.set("keepinform", true);
        localStorage.setItem('keepinform', 'true');  // string
      })
      .catch((error) => {
        this.setState({
          isDisabled: false
        })
        alert(error.toString());
      });
  };

  render() {
    const { t } = this.props;
    const gp_contact_mockup = `${process.env.PUBLIC_URL}/assets/images/gp_images/ecoshift-ecoshift-eco-app-movement-platform-ecoresponsible-ecopositive-ecofriendly-ecocentric-keepmeinformed.webp`;

    return (
      <div className="contact-form--1">
        <div className="container">
          <div className="row row--35 align-items-start">
            <div className="col-lg-12 order-2 order-lg-1">
              <div className="form-wrapper">
                <Row>
                  <Col className="lg-6">
                    <div className="">
                      <br />
                      <br />
                      <p className="section-title text-left-important mt-3">
                        {t("Keep me informed")}
                      </p>
                      <br />
                      <p className="text-left-important text-blod-description font-bold">
                        {t(
                          "Stay in the loop, and be among the first to hear about EcoShift’s launch and news!"
                        )}
                      </p>
                      <br />
                      <p className="text-left-important text-blod-description">
                        {t(
                          "We promise not to overflow your inbox. By registering here, expect occasional news about our progress, when the app is ready for you to download, and other key information along the way!"
                        )}
                      </p>
                    </div>
                    <AvForm
                      ref={this.formRef}
                      onValidSubmit={this.handleSendMessage}
                      onInvalidSubmit={(event, errors, values) => {
                        console.log("Invalid fields:", errors); // Debug invalid inputs
                      }}
                      className="authentication-form mt-30"
                    >
                      <Row>
                        <Col>
                          <AvGroup>
                            <InputGroup>
                              <InputGroupAddon addonType="prepend">
                                <span className="input-group-text">
                                  <User className="icon-dual" />
                                </span>
                              </InputGroupAddon>
                              <AvInput
                                type="text"
                                name="firstName"
                                value={this.state.firstName}
                                placeholder={t("First Name")}
                                onChange={(e) =>
                                  this.setState({ firstName: e.target.value })
                                }
                                required
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: t("This field is invalid"),
                                  },
                                }}
                                className={
                                  this.state.showAllErrors ? "is-invalid" : ""
                                }
                              />
                              <AvFeedback>
                                {t("This field is invalid")}
                              </AvFeedback>
                            </InputGroup>
                          </AvGroup>
                        </Col>
                      </Row>

                      <Row>
                        <Col>
                          <AvGroup>
                            <InputGroup>
                              <InputGroupAddon addonType="prepend">
                                <span className="input-group-text">
                                  <User className="icon-dual" />
                                </span>
                              </InputGroupAddon>
                              <AvInput
                                type="text"
                                name="lastName"
                                value={this.state.lastName}
                                placeholder={t("Last Name")}
                                onChange={(e) =>
                                  this.setState({ lastName: e.target.value })
                                }
                                required
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: t("This field is invalid"),
                                  },
                                }}
                                className={
                                  this.state.showAllErrors ? "is-invalid" : ""
                                }
                              />
                              <AvFeedback>
                                {t("This field is invalid")}
                              </AvFeedback>
                            </InputGroup>
                          </AvGroup>
                        </Col>
                      </Row>

                      <Row>
                        <Col>
                          <AvGroup className="mb-1">
                            <InputGroup>
                              <InputGroupAddon addonType="prepend">
                                <span className="input-group-text">
                                  <Mail className="icon-dual" />
                                </span>
                              </InputGroupAddon>
                              <AvInput
                                type="email"
                                name="email"
                                value={this.state.email}
                                placeholder={t("Email address")}
                                onChange={(e) =>
                                  this.setState({ email: e.target.value, displayEmail: e.target.value })
                                }
                                required
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: t("This field is invalid"),
                                  },
                                }}
                                className={
                                  this.state.showAllErrors ? "is-invalid" : ""
                                }
                              />
                              <AvFeedback>
                                {t("This field is invalid")}
                              </AvFeedback>
                            </InputGroup>
                          </AvGroup>
                        </Col>
                      </Row>

                      <Row>
                        <Col>
                          <br />
                          <p class="text-blod-description">
                            {t("Optional info:")}
                          </p>
                          <label class="checkbox-wrapper text-blod-description">
                            {t(
                              "I am an eco-certified professional, and would also like to know more about how to register my business on the platform."
                            )}
                            <AvInput
                              type="checkbox"
                              name="isPro"
                              value={this.state.isPro}
                              onChange={(e) =>
                                this.setState({ isPro: e.target.value })
                              }
                            />
                            <span class="checkbox-custom"></span>
                          </label>
                        </Col>
                      </Row>

                      <br />

                      <FormGroup className="form-group mb-0 text-center">
                        <div className="row align-items-center justify-content-center">
                          <Button
                            className="btn-default-green custom"
                            type="submit"
                            value="submit"
                            name="submit"
                            id="mc-embedded-subscribe"
                            disabled={this.state.isDisabled}
                          >
                            {t("Send")}
                          </Button>
                        </div>
                      </FormGroup>
                    </AvForm>

                    <Dialog
                      isOpen={this.state.showResultDialog}
                      onClose={this.toggleResultDialog}
                      title={this.state.isAlreadyRegistered ? t("Thank you!") : t("Almost there!")}
                    >
                      { this.state.isAlreadyRegistered ? <div className="text-blod-description justify-content-center align-items-center">
                        <p className="text-blod-description text-center-important">
                          {t("Thank you for registering again, your email is already saved. We will keep you informed.")}
                        </p>  </div> :
                      <div className="text-blod-description justify-content-center align-items-center">
                        <p className="text-blod-description text-center-important">
                          {t("A verification email has been sent to")}
                        </p>
                        <p className="text-blod-description text-center-important font-bold">
                          {this.state.displayEmail}
                        </p>
                        <p className="text-blod-description text-center-important mt-2">
                          {t(
                            "Check your inbox to verify your email address. If you can’t see the email, it may be in your spam!"
                          )}
                        </p>
                      </div> 
                      }
                    </Dialog>

                    {this.state.showDialog ? (
                      <ContactDialog
                        isOpen={this.state.showDialog}
                        onClose={this.toggleDialog}
                        handleSendMessage={this.handleSendMessage}
                      />
                    ) : (
                      <div />
                    )}
                  </Col>
                  <Col className="lg-6 display_on_mobile">
                    <br />
                    <br />
                    <br />
                    <img
                      className=""
                      style={{
                        maxWidth: "800px",
                        width: "100%",
                        height: "auto",
                        objectFit: "auto",
                      }}
                      src={gp_contact_mockup}
                      alt={t(
                        "ecoshift,ecoshift-eco,app,movement,platform,ecoresponsible,ecopositive,ecofriendly,ecocentric,keepmeinformed"
                      )}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withTranslation()(ContactOne);
